module.exports = __webpack_public_path__ + "img/logo.882704fa.svg";